import React, { Fragment, useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { Popup } from "@progress/kendo-react-popup";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import {
  nonRangeDateKeys,
  rangeDateKeys,
  getDateFromDateKey,
} from "../lib/utils";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

export const MyProDatePicker = (props) => {
  const { id, showRanges, onDateKeySelected, ...other } = props;

  const currentTheme = useSelector((state) => state.currentTheme);
  const popupRef = React.useRef(null);

  const [popupOpen, setPopupOpen] = useState(false);

  const { t } = useTranslation();

  //const [currentTabIndex, setCurrentTabIndex] = useState(0);
  const [refresh, setRefresh] = useState(0);

  const currentTabIndex = useRef(0);
  const handleOnTabSelect = (e) => {
    currentTabIndex.current = e.selected;
    setRefresh((state) => state + 1); //to re-render
  };

  const closeOnClickOutside = (e) => {
    if (
      !e.target.closest(".pro-datepicker-container") &&
      !e.target.closest(".pro-datepicker-popup-button")
    )
      setPopupOpen((state) => false);
  };

  useEffect(() => {
    window.addEventListener("click", closeOnClickOutside);

    return () => {
      window.removeEventListener("click", closeOnClickOutside);
    };
  }, []);

  const handleOnItemClick = (item, isRange) => {
    if (onDateKeySelected)
      onDateKeySelected({
        ...item,
        isRange: isRange,
        value: getDateFromDateKey(item.Id),
      });

    setPopupOpen(false);
  };

  if (showRanges == false && currentTabIndex.current == 1)
    currentTabIndex.current = 0;

  return (
    <Fragment>
      <div className={`pro-datepicker pro-datepicker-${id}`}>
        <DatePicker
          id={id}
          format={"yyyy-MMM-dd"}
          validityStyles={false}
          valid={true}
          {...other}
        />
        <div
          style={{
            marginTop: 0,
            marginLeft: 6,
            borderRadius: 4,
            border: `1px solid ${currentTheme.componentBorderColor}`,
          }}
        >
          <button
            type="button"
            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base pro-datepicker-popup-button"
            onClick={(e) => {
              setPopupOpen((state) => {
                const newState = !state;
                return newState;
              });
            }}
            ref={popupRef}
          >
            ...
          </button>
          <Popup
            anchor={popupRef.current}
            show={popupOpen}
            popupClass={"pro-datepicker-container"}
            anchorAlign={{ horizontal: "right", vertical: "top" }}
            popupAlign={{ horizontal: "right", vertical: "bottom" }}
            collision={{ horizontal: "fit", vertical: "flip" }}
          >
            <div className="pro-datepicker-content">
              <TabStrip
                selected={currentTabIndex.current}
                onSelect={handleOnTabSelect}
              >
                {showRanges && (
                  <TabStripTab key={0} title={t("myprodate.range")}>
                    <div className="tab">
                      {rangeDateKeys.map((item, index) => {
                        return (
                          <div key={item.Id} className="cell">
                            <span
                              onClick={(e) => handleOnItemClick(item, true)}
                            >
                              {item.Title}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  </TabStripTab>
                )}
                <TabStripTab key={1} title={t("myprodate.value")}>
                  <div className="tab">
                    {nonRangeDateKeys.map((item, index) => {
                      return (
                        <div key={item.Id} className="cell">
                          <span onClick={(e) => handleOnItemClick(item, false)}>
                            {item.Title}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </TabStripTab>
              </TabStrip>
            </div>
          </Popup>
        </div>
      </div>
      <style>
        {`
                .pro-datepicker
                {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    flex: 1;
                }

                .pro-datepicker .k-field
                {
                    flex: 1;
                }
                
                .pro-datepicker:nth-child(3)
                {
                    margin-left: 16px;
                }
                
                .pro-datepicker-popup-button
                {
                    padding: 3px 8px 3px 8px;
                    border-color: ${currentTheme.componentBorderColor};
                }

                .pro-datepicker-content
                {
                    padding: 12px;
                    max-width: 620px;
                }

                .pro-datepicker-content .tab
                {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: flex-start;
                    align-items: center;
                }

                .pro-datepicker-content .cell
                {
                    flex: 25%;
                    padding: 8px 8px 8px 0;
                }

                .pro-datepicker-content .cell span
                {
                    color: ${currentTheme.bodyText};
                }  
                
                .pro-datepicker-content .cell span:hover
                {
                    cursor: pointer;
                    font-weight: 600;
                    color: ${currentTheme.touchColor};
                }

            `}
      </style>
    </Fragment>
  );
};
